import Flex from 'src/styles/layouts/Flex';
import styled from 'styled-components';

export const FlexEx = styled(Flex)<{ forwardedAs: string | undefined }>`
	color: ${(p) => p.theme.colors.white};

	list-style: ${(p) => (p.forwardedAs === 'ol' ? 'auto' : 'outside')};
`;

export const StyledListItems = styled.li`
	::marker {
		font-family: 'Lato', sans-serif;
	}

	& + li {
		margin-top: 4px;
	}

	p {
		vertical-align: top;

		margin-top: -3px;
	}

	max-width: calc(100% - 32px);
`;
